/** @format */

import React, {useCallback, useEffect, useMemo, useState}                    from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, TextareaAutosize} from '@material-ui/core';
import I18n                                                                  from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { LinearBillingUploadReportMessage } from '../../../interfaces/billing/LinearBillingUploadReportMessage';
import TemplateButton                               from "../../../components/Buttons/TemplateButton";
import {PanoramaFishEye, Report, Visibility, Watch} from "@material-ui/icons";
import {PRICELIST_UPLOAD_STATUS}                    from "../../../modules/pricelists/helpers/PricelistUploadHelper";
import TariffInterface from "../../../interfaces/billing/TariffInterface";
import {ItemLoaders}                                         from "../../../core/loaders/ItemLoaders";
import {FormGeneralHelper} from "../../../helpers/FormGeneral";
import {configDefault} from "../../../core/config";
import Loader from "../../../components/Loaders/Loader";
import {NotificationHelper} from "../../../helpers/NotificationHelper";
import {useDispatch} from "react-redux";
import CustomTextButtom from "../../../components/Buttons/CustomTextButton";

const useStyle = makeStyles(adescomStyle);

interface PricelistUploadFileViewProps {
    open: boolean;
    tariff: TariffInterface;
    importId: number;
    closeDialog: () => void;
}

export const PricelistUploadFileView = (props: PricelistUploadFileViewProps): React.ReactElement => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const itemLoader = useMemo(() => {
        return new ItemLoaders(dispatch);
    }, [dispatch]);
    const [loading, setLoading] = useState<boolean>(false);
    const tariff = props.tariff;
    const importId = props.importId;
    const open = props.open;
    const [fileData, setFileData] = useState<string | null>(null);

    const getFileData = useCallback((): any => {
        if(!open) {
            return;
        }
        setLoading(true);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/custom_billing_actions')),
            'view_linear_billing_import_file',
            {
                action: 'view_linear_billing_import_file',
                params: JSON.stringify({
                    tariff: tariff,
                    importId: importId
                }),
            },
            {
                onSuccess: (data: any) => {
                    setFileData(atob(data));
                    setLoading(false);
                },
                onError: () => {
                    setLoading(false);
                    //
                },
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
                dispatchErrorAfterCallback: true,
            }
        );
    }, [importId, itemLoader, tariff, open]);

    const closeDialog = props.closeDialog;

    const onClose = useCallback((): void => {
        closeDialog();
    }, [closeDialog]);

    useEffect(() => {
        getFileData();
    }, [getFileData, open]);

    return (
        <>
            <Loader visible={loading} />
            <Dialog
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                open={open}
                onClose={onClose}
                maxWidth="xl"
            >
                <DialogTitle>
                    <I18n trans={'pricelists:import_report.view_file'} />
                </DialogTitle>
                <DialogContent>
                    {fileData && (
                        <textarea
                            style={{ maxWidth: '800px', maxHeight: '400px', minWidth: '800px', minHeight: '400px', overflowY: 'scroll', overflowX: 'scroll' }}
                            onChange={(): void => {}}
                            value={fileData}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <CustomTextButtom callback={onClose} callbackParam={{}} label="general:common.close" size="sm" />
                </DialogActions>
            </Dialog>
        </>
    );
};
